import { useState, useEffect } from 'react';
import { IconMap } from './helpers/iconMap';
import { IconDiv, IconSpan } from './Icon.styles';

/**
 * @param {IconProps} props
 * Rotation prop may be a number or a tuple [beforeRotation, afterRotation]; upstream components normalize tuple values to a single number before passing them here.
 * @returns {React.ReactElement} The rendered component
 */
const Icon = ({
  icon,
  className,
  checked,
  isMounted,
  parentHovered,
  color,
  dataId = icon,
  height,
  width,
  tag = 'span',
  rotation,
  iconSize = 'sm',
}) => {
  const [hovered, isHover] = useState(parentHovered ?? false);

  useEffect(() => {
    // TODO FRESEKAR-488: Error: Calling setState synchronously within an effect can trigger cascading renders
    // eslint-disable-next-line react-hooks/set-state-in-effect
    isHover(parentHovered || false);
  }, [parentHovered]);

  const IconComponent = IconMap[icon] || IconMap.DEFAULT;
  // Cast to any to avoid type incompatibilities with injected props

  const AnyIconComponent = /** @type {any} */ (IconComponent);

  // Apply rotation via wrapper span so we don't rely on styled transient props
  const iconElement = (
    <span
      style={
        rotation
          ? { display: 'flex', transform: `rotate(${rotation}deg)` }
          : { display: 'flex' }
      }
      className={className}
      data-id="icon-rotatable-wrapper"
    >
      <AnyIconComponent
        hovered={hovered}
        checked={checked}
        isMounted={isMounted}
        color={color}
        height={height}
        width={width}
        dataId={dataId}
        iconSize={iconSize}
      />
    </span>
  );

  if (tag === 'div') {
    // @ts-ignore
    return <IconDiv>{iconElement}</IconDiv>;
  }

  if (tag === 'none') {
    return iconElement;
  }

  return (
    <IconSpan
      onMouseEnter={() => isHover(true)}
      onMouseLeave={() => isHover(false)}
      data-id="icon-span"
    >
      {iconElement}
    </IconSpan>
  );
};

export default Icon;
